import tw, { styled } from 'twin.macro';

export const FooterContainer = styled.footer`
  ${tw`
    mt-10
    mx-auto
    px-4
    pb-6
    pt-5
  `}
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(65, 6, 16, 0.12) 76%, rgba(94, 8, 20, 0.18) 100%),
    rgba(0, 0, 0, 0.2);
`;

export const FooterGrid = styled.div`
  ${tw`
    mx-auto
    max-w-7xl
    grid
    gap-3
    items-start
  `}
  grid-template-columns: auto 1fr 1fr;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 1.25rem;
    text-align: center;
  }
`;

export const FooterLeft = styled.div`
  ${tw`text-center`}

  @media (max-width: 960px) {
    order: 1;
  }
`;

export const FooterCenter = styled.div`
  ${tw`
    text-xs
  `}
  color: rgba(214, 220, 230, 0.68);
  line-height: 1.5;

  @media (max-width: 960px) {
    order: 2;
  }
`;

export const FooterMadeWith = styled.p`
  ${tw`text-xs m-0`}
  color: rgba(203, 210, 220, 0.58);
  letter-spacing: 0.18px;
`;

export const FooterImage = styled.img`
  ${tw`mx-auto mt-1.5`}
  opacity: 0.85;
`;

export const FooterRight = styled.div`
  ${tw`
    flex
    flex-wrap
    items-center
    justify-between
    gap-2
  `}

  @media (max-width: 960px) {
    justify-content: center;
    order: 3;
  }
`;

export const FooterTextLink = styled.a`
  ${tw`text-xs`}
  color: rgba(233, 238, 246, 0.78);
  text-decoration: none;
  transition: color 180ms ease;

  &:hover {
    color: #fff;
  }
`;

export const FooterDivider = styled.span`
  color: rgba(255, 255, 255, 0.2);
  margin: 0 0.1rem;
`;

export const FooterIconLink = styled.a`
  ${tw`
    inline-flex
    items-center
    justify-center
    w-7
    h-7
  `}
  text-decoration: none;
  transition: opacity 180ms ease, transform 180ms ease;

  &:hover {
    opacity: 0.7;
    transform: scale(1.08);
  }

  img {
    width: 16px;
    height: 16px;
    filter: brightness(0) invert(1);
    opacity: 0.8;
  }
`;

export const FooterBackTop = styled.button`
  ${tw`
    text-xs
    inline-flex
    items-center
    gap-1
  `}
  background: transparent;
  border: none;
  color: rgba(236, 240, 246, 0.7);
  cursor: pointer;
  transition: color 180ms ease;

  &:hover {
    color: #fff;
  }
`;
